import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { Navigation } from "./components/site/Navigation";
import { Hero } from "./components/site/Hero";
import { About } from "./components/site/About";
import { Catalog } from "./components/site/Catalog";
import { WhyUs } from "./components/site/WhyUs";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { CartDrawer } from "./components/site/CartDrawer";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProductDetail from "./pages/ProductDetail";
import { getToken } from "./lib/api";

const PublicSite = () => (
  <>
    <Navigation />
    <CartDrawer />
    <main>
      <Hero />
      <Catalog />
      <About />
      <WhyUs />
      <Contact />
    </main>
    <Footer />
  </>
);

const ProtectedAdmin = () => {
  if (!getToken()) return <Navigate to="/admin/login" replace />;
  return <AdminDashboard />;
};

function App() {
  return (
    <div className="App bg-[#080706] text-[#FDF8F5] min-h-screen antialiased">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicSite />} />
            <Route path="/produs/:id" element={<ProductDetail />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedAdmin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0F0D0B",
            border: "1px solid #2A2522",
            color: "#FDF8F5",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
